import PublicFooter from './PublicFooter'
import PublicHeader from './PublicHeader'
import PublicHero from './PublicHero'
import {
  HowItWorksSection,
  PublicBenefitGrid,
  RetailerLogoStrip,
  TrustPaymentStrip,
} from './PublicSections'
import './public-home.css'

export default function PublicHomepage() {
  return (
    <div data-site-shell className="public-home">
      <PublicHeader />
      <div data-site-content className="public-home__canvas">
        <PublicHero />
        <div className="public-home__content">
          <PublicBenefitGrid />
          <TrustPaymentStrip />
          <HowItWorksSection />
          <RetailerLogoStrip />
        </div>
        <PublicFooter />
      </div>
    </div>
  )
}
